var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContentRating18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_111)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.981,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81036 -0.258621C10.4311 -0.258621 19.0517 -0.258621 27.6724 -0.258621C28.3423 0.252604 29.0319 0.769846 29.7414 1.2931C29.7414 10.2586 29.7414 19.2242 29.7414 28.1897C29.0518 28.5345 28.5345 29.0517 28.1897 29.7414C19.2242 29.7414 10.2586 29.7414 1.29312 29.7414C0.948289 29.0517 0.431049 28.5345 -0.258606 28.1897C-0.258606 19.3966 -0.258606 10.6034 -0.258606 1.81034C0.258635 0.948274 0.948289 0.25862 1.81036 -0.258621Z",
    fill: "#D54E4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6379 16.8103C11.1346 18.0765 10.9622 19.4558 11.1207 20.9483C10.2586 20.9483 9.39656 20.9483 8.53447 20.9483C8.69295 19.4558 8.52056 18.0765 8.01723 16.8103C7.28342 16.3184 6.42139 16.1459 5.43102 16.2931C5.43102 17.8448 5.43102 19.3966 5.43102 20.9483C4.39654 20.9483 3.36206 20.9483 2.32758 20.9483C2.32758 18.3621 2.32758 15.7759 2.32758 13.1897C6.82354 13.3611 11.3063 13.1886 15.7759 12.6724C18.2992 8.23236 21.7475 7.37028 26.1207 10.0862C28.9726 13.5754 28.8002 16.9375 25.6034 20.1724C21.3263 22.3676 18.0504 21.3331 15.7759 17.069C14.4072 16.8117 13.0279 16.7255 11.6379 16.8103Z",
    fill: "#FDF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9483 11.6379C23.95 11.7983 25.0707 13.35 24.3104 16.2931C20.9027 18.884 19.1785 18.0219 19.1379 13.7069C19.4947 12.7499 20.0981 12.0602 20.9483 11.6379Z",
    fill: "#D65351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01724 16.8103C8.52057 18.0765 8.69297 19.4558 8.53448 20.9483C9.39657 20.9483 10.2586 20.9483 11.1207 20.9483C10.9622 19.4558 11.1346 18.0765 11.6379 16.8103C11.6379 18.3621 11.6379 19.9138 11.6379 21.4655C10.4311 21.4655 9.22412 21.4655 8.01724 21.4655C8.01724 19.9138 8.01724 18.3621 8.01724 16.8103Z",
    fill: "#EEB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01723 16.8103C7.32759 16.8103 6.6379 16.8103 5.94827 16.8103C5.94827 18.3621 5.94827 19.9138 5.94827 21.4655C4.62449 21.6215 3.41759 21.4491 2.32758 20.9483C3.36206 20.9483 4.39654 20.9483 5.43102 20.9483C5.43102 19.3966 5.43102 17.8448 5.43102 16.2931C6.42139 16.1459 7.28342 16.3184 8.01723 16.8103Z",
    fill: "#E58D8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentRating18);
export default __webpack_public_path__ + "static/media/ic_content_rating_18.8b0bdf1e1604ffb27cfb4083d3bf49ce.svg";
export { ForwardRef as ReactComponent };